import { User } from '../../core/entities';
import { Permission } from '../../core/entities/permission.entity';
import { LoginResponse } from '../interfaces';

export class RenewMapper {
  static fromRenewResponseToEntity(loginResponse: LoginResponse) {
    return new User(
      loginResponse.userData.id,
      loginResponse.userData.name,
      loginResponse.userData.surname,
      loginResponse.userData.email,
      loginResponse.userData.indicativeNumber,
      loginResponse.userData.celphone,
      loginResponse.userData.documentType,
      loginResponse.userData.documentNumber,
      loginResponse.userData.companyName,
      loginResponse.userData.companyNit,
      new Permission(
        loginResponse.userData.userPermissions.general,
        loginResponse.userData.userPermissions.bancos,
        loginResponse.userData.userPermissions.cuentas,
        loginResponse.userData.userPermissions.movimientos,
        loginResponse.userData.userPermissions.predicciones,
        loginResponse.userData.userPermissions.usuarios
      ),
      loginResponse.userData?.rol?.name,
      loginResponse?.userData.department ?? undefined,
      loginResponse?.userData.city ?? undefined,
      loginResponse?.userData.address ?? undefined
    );
  }
}
